import React from 'react';
import { rootLinks } from '../Links';
import styles from './Services.module.scss';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import Link from 'next/link';
import type { ServicesProps, ServicesTab } from './Services.type';
import { ServicesTiles } from './ServicesTiles';

export const tabs: ServicesTab[] = [
    {
        name: 'customers',
        title: 'Заказчикам',
        href: `${rootLinks.services.url}/customers`,
    },
    {
        name: 'participants',
        title: 'Участникам',
        href: `${rootLinks.services.url}/participants`,
    },
];

export const Services: React.FC<ServicesProps> = React.memo(({ activeTab }) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Сервисы ESTP</h1>
            <div className={styles.tabs}>
                {tabs.map((tab) => (
                    <Link key={tab.name} href={tab.href}>
                        <a
                            className={clsx(
                                styles.tabItem,
                                activeTab === tab.name && styles.active
                            )}
                        >
                            {tab.title}
                        </a>
                    </Link>
                ))}
            </div>
            <ServicesTiles activeTab={activeTab} />
        </div>
    );
});
